import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddUmbrella from "../../components/UmbrellaManagement/AddUmbrella";
// import UmbrellaTable from "../../components/UmbrellaManagement/UmbrellaTable";





const AddUmbrellaPage = () => {
    return (
        <>
        
            <MasterLayout>

                <Breadcrumb title="Add Umbrella" />
                {/* <UmbrellaTable/> */}
                <AddUmbrella/>


   
           



            </MasterLayout>
        </>
    );
};

export default AddUmbrellaPage;
